/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExportFile } from '../models/ExportFile';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExportFileService {

    /**
     * Get list of exportFile
     * @returns ExportFile Success
     * @throws ApiError
     */
    public static getExportFileList({
        limit,
        offset,
        sort,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Sorting options
         */
        sort?: Record<string, any>,
    }): CancelablePromise<Array<ExportFile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/exportFile',
            query: {
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Download Export File
     * @returns any Success
     * @throws ApiError
     */
    public static downloadExportFile({
        id,
    }: {
        /**
         * Export File ID
         */
        id: number,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/exportFile/{id}/download',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
